import React from 'react';
import { Badge, StatusDot } from '../../../components/ui';
import { STATUS_MAP, type EmployeeStatus } from './status.js';

interface StatusBadgeProps {
  status: EmployeeStatus;
  label?: string;
  compact?: boolean;
}

export const StatusBadge: React.FC<StatusBadgeProps> = ({ status, label, compact }) => {
  const meta = STATUS_MAP[status];
  const variantToDot: Partial<Record<typeof meta.variant, Parameters<typeof StatusDot>[0]['variant']>> = {
    success: 'success',
    warning: 'warning',
    danger: 'danger',
    neutral: 'neutral',
    info: 'info',
  };
  return (
    <Badge
      variant={meta.variant}
      size={compact ? 'sm' : 'md'}
      icon={<StatusDot variant={variantToDot[meta.variant] ?? 'neutral'} size="sm" />}
    >
      {label ?? meta.label}
    </Badge>
  );
};
